<template>
  <section id="hero">
    <svg
      id="hexa"
      width="100vw"
      :height="windowHeight"
    >
      <g>
        <g
          v-for="(item, i) in nubePuntos"
          :key="i"
          :transform="`matrix( 1, 0, 0, 1, ${item.eX}, ${item.eY})`"
          class="objeto"
          :class="i === 0 ? centredClass : ''"
          @click="item.menu ? clickMenu(item.menu.option) : clickMenu(i)"
          @mouseover="i === 0 ? changeLogoClass(true) : overedHexagon(i, true)"
          @mouseout="i === 0 ? changeLogoClass(false) : overedHexagon(i, false)"
        >
          <g :transform="`matrix( ${factor}, 0, 0, ${factor}, 0, 0)`">
            <polygon
              :points="points"
              class="hexagon"
            />
            <text
              v-if="item.menu"
              :x="hexagonoWidth / 2"
              :y="diametro / 2"
              :font-size="fontSizeCustom"
              class="demo-icon"
              text-anchor="middle"
              alignment-baseline="middle"
            >{{ domDecoder(item.menu.customIcon) }}</text>
            <text
              v-if="item.menu"
              :x="hexagonoWidth / 2"
              :y="diametro / 2"
              font-size="14px"
              class="overed"
              text-anchor="middle"
              alignment-baseline="middle"
            >{{ domDecoder(item.menu.literal) }}</text>
            <text
              v-if="!item.menu && i !== 0"
              :x="hexagonoWidth / 2"
              :y="diametro / 2"
              :font-size="fontSizeCustom"
              class="demo-icon no-icon"
              text-anchor="middle"
              alignment-baseline="middle"
            >&#xe81A;</text>
          </g>
        </g>
      </g>
      <g
        id="logo"
        :class="logoClass"
        :transform="`matrix(${logoEscala}, 0, 0, ${logoEscala}, ${logoPosX}, ${logoPosY})`"
        @mouseover="changeLogoClass(true)"
        @mouseout="changeLogoClass(false)"
      >
        <g :transform="`matrix( ${factor}, 0, 0, ${factor}, 0, 0)`">
          <logo @clicado="clickMenu(0)" />
        </g>
      </g>
      <g v-if="checkDev">
        <circle
          v-for="(item, i) in nubePuntos"
          :key="i"
          :cx="item.x"
          :cy="item.y"
          r="50"
          stroke="none"
          :fill="rangoColor[distancias.indexOf(item.distancia)]"
        />
      </g>
    </svg>
  </section>
</template>

<script>
  import Logo from '@/components/Logo'
  export default {
    name: 'SectionHero',

    components: {
      Logo,
    },

    provide: {
      theme: { isDark: true },
    },

    data: () => ({
      menu: [
        // {
        //   literal: 'Inicio',
        //   option: '',
        //   icon: 'home',
        //   customIcon: '&#xe801;',
        // },
        {
          literal: 'Quiénes Somos',
          option: 'about',
          icon: 'people',
          customIcon: '&#xe802;',
        },
        {
          literal: 'Qué Hacemos',
          option: 'jobs',
          icon: 'power',
          customIcon: '&#xe803;',
        },
        {
          literal: 'Dónde Estamos',
          option: 'contact-us',
          icon: 'place',
          customIcon: '&#xe806;',
        },
        {
          literal: 'Nuestro Equipo',
          option: 'team',
          icon: 'folder_shared',
          customIcon: '&#xe804;',
        },
        {
          literal: 'Nuestros Clientes',
          option: 'clients',
          icon: 'business_center',
          customIcon: '&#xe805;',
        },
        {
          literal: 'Nuestros Trabajos',
          option: 'jobs',
          icon: 'wb_incandescent',
          customIcon: '&#xe810;',
        },
        {
          literal: 'Contáctanos',
          option: 'contact-us',
          icon: 'sms',
          customIcon: '&#xe807;',
        },
      ],
      menu2: [
        {
          literal: 'Teléfono',
          option: 'contact-us?v=tlf',
          icon: 'phone',
          customIcon: '&#xe808;',
        },
        // {
        //   literal: 'Whatsapp',
        //   option: 'whatsapp',
        //   icon: 'whatsapp',
        //   customIcon: '&#xe809;',
        // },
        // {
        //   literal: 'Facebook',
        //   option: 'facebook',
        //   icon: 'facebook',
        //   customIcon: '&#xe806;',
        // },
        // {
        //   literal: 'Twitter',
        //   option: 'twitter',
        //   icon: 'twitter',
        //   customIcon: '&#xe804;',
        // },
      ],
      checkDev: false,
      logoClass: 'logo',
      centredClass: 'centrado',
      objetoClass: 'objeto',
      isDev: false,
      diametro: 150,
      fontSizeCustom: '3em',
      rangoColor: [
        '#e82f2f',
        '#ae560f',
        '#ece0e0',
        '#f0e368',
        '#121111',
        '#244474',
        '#1A1A8F',
        '#A36490',
        '#51CDC8',
        '#C45A33',
        '#90D0B1',
        '#F28771',
        '#B64CC7',
        '#2A14AC',
        '#3463C1',
        '#B6EBA0',
        '#9D89E2',
        '#8C9158',
        '#C527FA',
        '#F02A9D',
        '#74D2B7',
        '#8162A8',
        '#21EC39',
        '#AD78FC',
      ],
      // windowWidth: 0,
      // windowHeight: 0,
      factor: 0.96,
      menuAlter: false,
      angleDefault: 30,
    }),

    computed: {
      windowHeight () {
        return `calc(100vh - ${this.$vuetify.application.top}px)`
      },

      windowWidth () {
        return this.$vuetify.breakpoint.width // '100vw'
      },

      centerH () {
        return this.$vuetify.breakpoint.width / 2
      },

      centerV () {
        // return this.$vuetify
        return (this.$vuetify.breakpoint.height - this.$vuetify.application.top) / 2
      },

      hexagonoWidth () {
        return parseInt(((Math.sqrt(3) * this.diametro) / 4) * 2 * 100) / 100
      },

      positionsX () {
        let loop = true
        const x = []
        let conta = 1
        while (loop) {
          const partida = this.centerH - this.hexagonoWidth / 2
          const aumento = this.hexagonoWidth * conta
          x.push(partida - aumento)
          x.push(partida + aumento)
          if (x[x.length - 1] > this.$vuetify.breakpoint.width) {
            // + this.hexagonoWidth
            x.push(partida)
            x.sort(function (a, b) {
              return a - b
            })
            loop = false
            break
          }
          conta++
        }
        return x
      },

      positionsY () {
        let loop = true
        const y = []
        let conta = 1
        while (loop) {
          const partida = this.centerV - (this.diametro - this.diametro / 4) / 2
          const aumento = (this.diametro - this.diametro / 4) * conta
          y.push(partida - aumento)
          y.push(partida + aumento)
          if (y[y.length - 1] > this.$vuetify.breakpoint.height) {
            // + this.diametro
            y.push(partida)
            y.sort(function (a, b) {
              return a - b
            })
            loop = false
            break
          }
          conta++
        }
        return y
      },

      items () {
        const x = this.positionsX
        const y = this.positionsY
        const result = []
        const centroX = this.centerH - this.hexagonoWidth / 2
        const centroY = this.centerV - (this.diametro - this.diametro / 4) / 2
        for (let index = 0; index < x.length; index++) {
          const coordX = x[index]
          for (let i = 0; i < y.length; i++) {
            const desplazamiento = coordX + this.hexagonoWidth / 2
            const coordY = y[i]
            let centred = false
            if (coordX === centroX && coordY === centroY) {
              centred = true
            }
            const xRes = i % 2 === 0 ? coordX : desplazamiento
            result.push({
              x: xRes,
              y: coordY,
              c: centred,
              difX: Math.abs(this.centerH - Math.abs(xRes)),
              difY: Math.abs(this.centerH - Math.abs(coordY)),
            })
          }
        }
        return result
      },

      centradoPanel () {
        let difX = 0
        let difY = 0
        const item = this.items.filter(item => item.c)
        const centroX = this.centerH - this.hexagonoWidth / 2
        const centroY = this.centerV - this.diametro / 2
        if (item) {
          difX = centroX - item[0].x
          difY = centroY - item[0].y
        }
        return `matrix( 1, 0, 0, 1, ${difX}, ${difY})`
      },

      points () {
        return this.puntos.map(
          item =>
            `${parseInt(item[0] * 100) / 100},${parseInt(item[1] * 100) / 100} `,
        ) // + this.correctionX // item[1] + this.correctionY
      },

      puntos () {
        const pts = []
        for (let i = 0; i < 6; i++) {
          const point = this.valueToPoint(i)
          pts.push([point.x, point.y])
        }
        return pts
      },

      fontSize () {
        return this.windowWidth > 600 ? '1.15em' : '1em'
      },

      fontSizeLogo () {
        // return this.windowWidth > 600 ? '5em' : '3em'
        return '7em'
      },

      fontSizeLogoCenter () {
        return `${this.diametro}px`
      },

      logoEscala () {
        return this.diametro / 10047
      },

      logoPosX () {
        return this.centerH - this.hexagonoWidth / 2
      },

      logoPosY () {
        return this.centerV - this.diametro / 2
      },

      offset () {
        /**
         * Pasos en el eje Y = (cuerda circulo circunscrito[exterior]) / 2 => this.diametro * (Math.PI / 180) * 120 / 2 => this.diametro * Math.PI / 3
         * Pasos en el eje X = (radio circulo inscrito[interior]) => this.hexagonoWidth / 2
         */
        const ejeY =
          parseInt(
            this.hexagonoWidth * Math.sin(((Math.PI / 180) * 120) / 2) * 100,
          ) / 100 // this.hexagonoWidth * Math.PI / 3
        const ejeX = this.hexagonoWidth / 2
        return { x: ejeX, y: ejeY }
      },

      distributionX () {
        const totalPointsX = this.windowWidth / this.offset.x
        const result = {
          l0: Math.ceil(totalPointsX / 2),
          l1: Math.ceil(totalPointsX / 2),
        }
        result.l0 = result.l0 > result.l1 ? result.l0 : result.l0 + 1
        if (result.l0 % 2 === 0) {
          result.l0 = result.l0 + 1
        } else {
          result.l1 = result.l1 + 1
        }
        // const parX = result % 2 === 0 ? Math.ceil(totalPointsX) + 1 : Math.ceil(totalPointsX)
        return result
      },

      distributionY () {
        const result = Math.ceil(
          (this.$vuetify.breakpoint.height - this.$vuetify.application.top + this.diametro / 3) / this.offset.y,
        )
        return result % 2 === 0 ? result + 1 : result
      },

      nubePuntos () {
        const result = []
        const l0 = this.distributionX.l0
        const columnas = this.distributionY
        const central = [
          {
            x: this.centerH,
          },
        ]
        for (let index = 1; index < Math.ceil(l0 / 2); index++) {
          central.push({
            x:
              this.centerH -
              2 * this.offset.x * index,
          })
          central.push({
            x:
              this.centerH +
              2 * this.offset.x * index,
          })
        }
        for (let indexY = 0; indexY < Math.ceil(columnas / 2); indexY++) {
          const y = this.offset.y * indexY
          let offset = 0
          if (indexY % 2 !== 0) {
            offset = this.offset.x
          }
          for (let index = 0; index < central.length; index++) {
            const element = Object.assign({}, central[index])
            element.x = element.x + offset
            element.eX = element.x - this.hexagonoWidth / 2
            element.y = this.centerV + y
            element.eY = element.y - this.diametro / 2
            element.grupoY = indexY

            // Cálculo de distancias al centro:
            // Base numérica
            const nBase = this.diametro
            const puntoA = element.x
            const puntoB = element.y
            const catetoA = Math.abs(this.centerH - puntoA)
            const catetoB = Math.abs(this.centerV - puntoB)
            let hipotenusa = 0
            if (puntoA === 0) {
              hipotenusa = catetoB
            } else if (puntoB === 0) {
              hipotenusa = catetoA
            } else {
              hipotenusa = Math.sqrt(catetoA * catetoA + catetoB * catetoB)
            }

            element.distancia = Math.ceil(parseInt(hipotenusa) / nBase)
            // --
            // Index
            element.index = result.length
            result.push(element)
          }
          if (indexY > 0) {
            const espejo = result.filter(item => item.grupoY === indexY)
            for (let i = 0; i < espejo.length; i++) {
              const element = Object.assign({}, espejo[i])
              element.y = this.centerV - y
              element.eY = element.y - this.diametro / 2
              element.index = result.length
              result.push(element)
            }
          }
        }
        // asignar iconos
        const menuPrincipal = this.menu
        const secondMenu = this.menu2
        const menu = secondMenu
          ? menuPrincipal.concat(secondMenu)
          : menuPrincipal
        const menuLength = menu.length
        let distancia = 1
        let indexMenu = 0
        let condi = true
        while (condi) {
          const select = result
            .filter(item => item.distancia === distancia)
            .map(item => item.index)
          for (let index = 0; index < select.length; index++) {
            const idx = select[index]
            result[idx].menu = Object.assign({}, menu[indexMenu])
            indexMenu++
            if (indexMenu > menuLength - 1) {
              condi = false
              break
            }
          }
          distancia++
          if (indexMenu > menuLength - 1 || distancia > 3) {
            condi = false
            break
          }
        }
        return result
      },

      distancias () {
        const array = this.nubePuntos
        const result = []
        for (let index = 0; index < array.length; index++) {
          const element = array[index]
          if (result.indexOf(element.distancia) < 0) {
            result.push(element.distancia)
          }
        }
        result.sort(function (a, b) {
          return a - b
        })
        return result
      },

      /* cssVar () {
        return {
          '--paleta-color-1': this.colores.color1,
          '--paleta-color-2': this.colores.color2,
          '--paleta-color-3': this.colores.color3,
          '--paleta-color-4': this.colores.color4,
          '--paleta-color-5': this.colores.color5,
          '--paleta-color-10': this.colores.color10,
          '--paleta-color-11': this.colores.color11,
          '--paleta-color-12': this.colores.color12,
        }
      }, */
    },

    methods: {
      overedHexagon (index, isOver) {
        return `overedHexagon ${index} => ${isOver}`
      },

      changeLogoClass (check) {
        this.logoClass = check ? 'logo-hover' : 'logo'
        this.centredClass = check ? 'centrado centrado-hover' : 'centrado'
      },

      domDecoder (str) {
        const parser = new DOMParser()
        const dom = parser.parseFromString(
          '<!doctype html><body>' + str,
          'text/html',
        )
        return dom.body.textContent
      },

      clickMenu (option) {
        // eslint-disable-next-line no-console
        console.log('Pulsado botón:')
        // eslint-disable-next-line no-console
        console.log(option)
        this.$router.push(option)
        // this.changePage(option)
      },

      changePage (option) {
        this.$emit('change-page', option)
      },

      valueToPoint (index) {
        /**
         * angle = Math.PI / 180 * 60  * index :
         * - Math.PI / 180 => Convierte de grados a radianes
         * - 60 => es el ángulo en grados entre cada punto y el contiguo del hexágono
         * - index => [0,...,5] => cada uno de los puntos del hexágono
         */
        const x = 0
        const y = -this.diametro * 0.5
        const angle = (Math.PI / 180) * 60 * index
        const cos = Math.cos(angle)
        const sin = Math.sin(angle)
        const tx = x * cos - y * sin + this.hexagonoWidth / 2
        const ty = x * sin + y * cos + this.diametro / 2
        return {
          x: tx,
          y: ty,
        }
      },

      valueToPosition (centre) {
        // Devuelve los 6 puntos centrales de los 6 hexagonos colindantes
        const cuerda = ((this.diametro * Math.PI) / 180) * 120
        const y = cuerda / 2
        const result = [
          [centre.x - this.hexagonoWidth * 1.5, centre.y - this.diametro / 2],
          [centre.x - this.hexagonoWidth, centre.y - y - this.diametro / 2],
          [centre.x, centre.y - y - this.diametro / 2],
          [centre.x + this.hexagonoWidth / 2, centre.y - this.diametro / 2],
          [centre.x, centre.y + y - this.diametro / 2],
          [centre.x - this.hexagonoWidth, centre.y + y - this.diametro / 2],
        ]
        return result
      },

      colorAleatorio () {
        const hexadecimal = [
          '0',
          '1',
          '2',
          '3',
          '4',
          '5',
          '6',
          '7',
          '8',
          '9',
          'A',
          'B',
          'C',
          'D',
          'E',
          'F',
        ]
        let colorAleatorio = '#'
        for (let i = 0; i < 6; i++) {
          const posarray = this.aleatorio(0, hexadecimal.length)
          colorAleatorio += hexadecimal[posarray]
        }
        return colorAleatorio
      },

      aleatorio (inferior, superior) {
        const numPosibilidades = superior - inferior
        let aleat = Math.random() * numPosibilidades
        aleat = Math.floor(aleat)
        return parseInt(inferior) + aleat
      },
    },
  }
</script>

<style scoped>
@font-face {
  font-family: 'fontello';
  src: url('../../assets/font/fontello.eot?44625968');
  src: url('../../assets/font/fontello.eot?44625968#iefix') format('embedded-opentype'),
        url('../../assets/font/fontello.woff?44625968') format('woff'),
        url('../../assets/font/fontello.ttf?44625968') format('truetype'),
        url('../../assets/font/fontello.svg?44625968#fontello') format('svg');
  font-weight: normal;
  font-style: normal;
}
svg {
  --paleta-color-1: #0c64a6;
  --paleta-color-2: #007cd6;
  --paleta-color-3: #1a92ea;
  --paleta-color-4: #7ab3dd;
  --paleta-color-5: #ffffff;
  --paleta-color-10: #e75418;
  --paleta-color-11: #c04233;
  --paleta-color-12: #3a3a3a;
  --paleta-color-20: #3e6109;
  background: var(--paleta-color-3);
}
.objeto {
  fill: var(--paleta-color-3);
  stroke: var(--paleta-color-4);
  stroke-width: 2px;
  cursor: pointer;
  -webkit-animation: in-hexagon 0.2s ease-in; /* Safari 4+ */
  -moz-animation: in-hexagon 0.2s ease-in; /* Fx 5+ */
  -o-animation: in-hexagon 0.2s ease-in; /* Opera 12+ */
  animation: in-hexagon 0.2s ease-in; /* IE 10+, Fx 29+ */
}
.objeto:not(.centrado):hover {
  fill: var(--paleta-color-2);
}
.objeto text {
  stroke: none;
  font-family: "Roboto";
  fill: var(--paleta-color-1);
  -webkit-animation: in-logo 0.5s ease-in; /* Safari 4+ */
  -moz-animation: in-logo 0.5s ease-in; /* Fx 5+ */
  -o-animation: in-logo 0.5s ease-in; /* Opera 12+ */
  animation: in-logo 0.5s ease-in; /* IE 10+, Fx 29+ */
}
.objeto:hover text {
  fill: var(--paleta-color-5);
}
.total-dev {
  position: absolute;
  top: 10px;
  left: 10px;
}
#logo {
  -webkit-animation: in-logo 0.3s ease-in; /* Safari 4+ */
  -moz-animation: in-logo 0.3s ease-in; /* Fx 5+ */
  -o-animation: in-logo 0.3s ease-in; /* Opera 12+ */
  animation: in-logo 0.3s ease-in; /* IE 10+, Fx 29+ */
}
.logo {
  fill: var(--paleta-color-5);
  stroke: none;
  cursor: pointer;
}
.logo-hover {
  fill: var(--paleta-color-20);
  stroke: none;
  cursor: pointer;
}
.menu-superior {
  height: 100vh;
}
.objeto text.demo-icon {
  fill: var(--paleta-color-4);
  font-family: "fontello";
  font-style: normal;
  font-weight: normal;
  /* speak: none; */

  display: inline-block;
  text-decoration: inherit;
  width: 1em;
  margin-right: 0.2em;
  text-align: center;
  /* opacity: .8; */

  /* For safety - reset parent styles, that can break glyph codes*/
  font-variant: normal;
  text-transform: none;

  /* fix buttons height, for twitter bootstrap */
  line-height: 1em;

  /* Animation center compensation - margins should be symmetric */
  /* remove if not needed */
  margin-left: 0.2em;

  /* You can be more comfortable with increased icons size */
  /* font-size: 120%; */

  /* Font smoothing. That was taken from TWBS */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  /* Uncomment for 3D effect */
  /* text-shadow: 1px 1px 1px rgba(127, 127, 127, 0.3); */
}
.objeto text.demo-icon.logo {
  fill: var(--paleta-color-5);
}

.objeto text.overed {
  display: none;
}

.objeto:hover text:not(.no-icon) {
  display: none;
}
.objeto:hover text.overed {
  display: block;
}

@-webkit-keyframes in-hexagon {
  0% {
    stroke-width: 150px;
  }
  100% {
    stroke-width: 3px;
  }
}
@-moz-keyframes in-hexagon {
  0% {
    stroke-width: 150px;
  }
  100% {
    stroke-width: 3px;
  }
}
@-o-keyframes in-hexagon {
  0% {
    stroke-width: 150px;
  }
  100% {
    stroke-width: 3px;
  }
}
@keyframes in-hexagon {
  0% {
    stroke-width: 150px;
  }
  100% {
    stroke-width: 3px;
  }
}

@-webkit-keyframes in-logo {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@-moz-keyframes in-logo {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@-o-keyframes in-logo {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes in-logo {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
